"use client";

import { useTranslations } from "next-intl";
import type React from "react";

import { NomboxLogo } from "@/components/shared/NomboxLogo";
import { Link } from "@/i18n/navigation";

interface NavbarProps {
  leftSlot?: React.ReactNode;
  centerSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  showLogo?: boolean;
}

export function Navbar({ leftSlot, centerSlot, rightSlot, showLogo = true }: NavbarProps) {
  const t = useTranslations("common");

  return (
    <nav className="sticky top-0 h-[var(--navbar-height)] pt-[env(safe-area-inset-top)] bg-surface-glass backdrop-blur-lg backdrop-saturate-150 border-b border-border flex items-center px-3 z-50">
      {/* LEFT */}
      <div className="flex-none min-w-8 flex items-center gap-3 sm:gap-4">
        {showLogo && (
          <Link
            href="/discover"
            aria-label={t("home")}
            className="flex items-center gap-1 hover:opacity-80 transition-opacity"
            prefetch={true}
          >
            <NomboxLogo className="text-foreground" />
            <h1 className="text-2xl font-bold hidden sm:block">Nombox</h1>
          </Link>
        )}
        {leftSlot}
      </div>

      {/* CENTER - absolutely centered and constrained via inline style; add fade mask */}
      <div className="absolute inset-x-0 mx-auto text-center max-w-[60%] min-w-0 px-2 pointer-events-none truncate text-lg font-semibold mask-fade">
        {centerSlot}
      </div>

      {/* RIGHT */}
      <div className="ml-auto flex-none min-w-8 flex items-center gap-3 sm:gap-4">{rightSlot}</div>
    </nav>
  );
}
